import React from "react";
import {Table, TableColumn} from "../tables/Table";
import {TablePage} from "../../model/utils/TablePage";
import {useFiltersActions} from "../../hooks/useFiltersActions";
import {TableFilterKey} from "../../model/filters/TableFiltersDefinitions";
import {TableColumnPopupContent} from "../ui/table-components/TableColumnPopupContent/TableColumnPopupContent";
import {SortedOrder} from "../../model/utils/SortedOrder";
import {useAppSelector} from "../../hooks/useAppSelector";
import {Log, LogsSortedField} from "../../model/logs/Logs";


interface TableProps {
    data: TablePage<Log>;
}

export function LogsTable(props: TableProps) {
    const {updateFilterPage, updateFilterAndClearData} = useFiltersActions();

    const filtersState = useAppSelector(state => state.sessionStorage.filters)
    const filter = filtersState[TableFilterKey.LOGS_FILTER].filter;

    const setSortingBy = (currentSortedField: LogsSortedField) => () => {
        if (filter.sortedField !== currentSortedField) {
            updateFilterAndClearData({
                key: TableFilterKey.LOGS_FILTER,
                value: {...filter, sortOrder: SortedOrder.ASC, sortedField: currentSortedField, pageNumber: 0}
            })
        } else {
            if (filter.sortOrder === "ASC") {
                updateFilterAndClearData({
                    key: TableFilterKey.LOGS_FILTER,
                    value: {...filter, sortOrder: SortedOrder.DSC, pageNumber: 0}
                })
            } else if (filter.sortOrder === "DSC") {
                updateFilterAndClearData({
                    key: TableFilterKey.LOGS_FILTER,
                    value: {...filter, sortOrder: null, sortedField: null, pageNumber: 0}
                })
            }
        }
    }

    const timeColumn: TableColumn<Log> = {
        columnName: 'Дата',
        extractCellContent: row => row.request.time,
        sortingFunction: setSortingBy(LogsSortedField.TIME),
        columnFieldName: LogsSortedField.TIME,
    }

    const userColumn: TableColumn<Log> = {
        columnName: 'Пользователь',
        extractCellContent: row => row.user.fullName || "–",
        sortingFunction: setSortingBy(LogsSortedField.USER),
        columnFieldName: LogsSortedField.USER,
        popupContent: <TableColumnPopupContent tableFilterKey={TableFilterKey.LOGS_FILTER}
                                               filterFieldName={'userSearch'}/>,
    }

    const uriColumn: TableColumn<Log> = {
        columnName: 'URI',
        extractCellContent: row => row.request.uri,
        sortingFunction: setSortingBy(LogsSortedField.URI),
        columnFieldName: LogsSortedField.URI,
        popupContent: <TableColumnPopupContent tableFilterKey={TableFilterKey.LOGS_FILTER}
                                               filterFieldName={'uriSearch'}/>,
    }

    const methodColumn: TableColumn<Log> = {
        columnName: 'Метод',
        title: 'Метод запроса',
        extractCellContent: row => row.request.method,
        sortingFunction: setSortingBy(LogsSortedField.METHOD),
        columnFieldName: LogsSortedField.METHOD,
    }

    const responseCodeColumn: TableColumn<Log> = {
        columnName: 'Код ответа',
        extractCellContent: row => row.responseCode,
        sortingFunction: setSortingBy(LogsSortedField.CODE),
        columnFieldName: LogsSortedField.CODE,
        popupContent: <TableColumnPopupContent tableFilterKey={TableFilterKey.LOGS_FILTER}
                                               filterFieldName={'responseCodeSearch'}/>,
    }

    const ipColumn: TableColumn<Log> = {
        columnName: 'IP',
        extractCellContent: row => row.user.ip,
        popupContent: <TableColumnPopupContent tableFilterKey={TableFilterKey.LOGS_FILTER}
                                               filterFieldName={'ipSearch'}/>,
    }

    return (
        <Table<Log>
            tableColumns={[timeColumn, userColumn, uriColumn, methodColumn, responseCodeColumn, ipColumn]}
            rows={props.data.rows}
            tableFilterKey={TableFilterKey.LOGS_FILTER}
            pagination={{
                currentPageNumber: props.data.pageNumber,
                quantityOfPages: props.data.pageCount,
                setPageNumber: (newPageNumber: number) => {
                    updateFilterPage({key: TableFilterKey.LOGS_FILTER, value: newPageNumber})
                }
            }}
        />
    )
}